import * as React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from "@material-ui/core";
import PropTypes from "prop-types";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { Formik } from "formik";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import dayjs from "dayjs";
import useCreditManagement from "../../hooks/useCreditManagement";
import SearchDropdown from "../../components/common/SearchDropdown";
import { creditEdit } from "../../validations/credit";
import CustomDialogTitle from "../../components/common/CustomDialogTitle";

const interestRateTypes = [
  { label: "Lãi ngày (k/triệu)", value: 1, id: "1", key: 1 },
  { label: "Lãi ngày (k/ngày)", value: 2, id: "2", key: 2 },
  { label: "Lãi tháng (%)(30/ngày)", value: 3, id: "3", key: 3 },
  { label: "Lãi tháng (định kỳ)", value: 4, id: "4", key: 4 },
  { label: "Lãi tuần (%)", value: 5, id: "5", key: 5 },
  { label: "Lãi tuần (VNĐ)", value: 6, id: "6", key: 6 },
  { label: "Theo tháng định kỳ (VNĐ)", value: 7, id: "7", key: 7 }
];

const Edit = ({ open, handleClose, data }) => {
  const { edit } = useCreditManagement();
  // const [textFormality, setTextFormality] = React.useState("1");
  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <CustomDialogTitle
          title="Cập nhật hợp đồng tín chấp"
          handleClose={handleClose}
        />
        <Formik
          initialValues={{
            // isNewClient: data.isNewClient || 1,
            customerName: data.customerName,
            customerIdNumber: data.customerIdNumber,
            address: data.address,
            phone: data.phone,
            collateralType: data.collateralType,
            loanAmount: data.loanAmount,
            interestForm: data.interestForm,
            numberPeriod: data.numberPeriod,
            interestTerm: data.interestTerm,
            interestRate: data.interestRate,
            notes: data.notes,
            collectMoney: data.collectMoney,
            loanDate: data.loanDate ? dayjs(data.loanDate) : dayjs(),
            receiver: data.receiver,
            id: data.id
          }}
          validationSchema={creditEdit()}
          onSubmit={async (values, actions) => {
            await edit(values, actions);
            handleClose();
          }}
        >
          {({
            errors,
            handleChange,
            touched,
            isSubmitting,
            values,
            handleSubmit,
            handleBlur,
            setFieldValue
          }) => {
            // const selectedTypeLend = typeLend.find(item => item.value === values.period);
            let { interestForm } = values;
            interestForm = parseInt(interestForm);
            let textUnit = "Ngày";
            let exampleUnit = 10;

            if (
              interestForm === 0 ||
              interestForm === 1 ||
              interestForm === 2
            ) {
              textUnit = "Ngày";
              exampleUnit = 10;
            } else if (
              interestForm === 3 ||
              interestForm === 4 ||
              interestForm === 7
            ) {
              textUnit = "Tháng";
              exampleUnit = 1;
            } else if (interestForm === 5 || interestForm === 6) {
              textUnit = "Tuần";
              exampleUnit = 1;
            }
            const textExample = `${exampleUnit} ${textUnit.toLowerCase()} đóng lãi 1 lần thì điền số ${exampleUnit}`;
            const numberPeriodTex = `Số ${textUnit.toLowerCase()} vay`;
            return (
              <>
                <DialogContent>
                  <Typography
                    color="textPrimary"
                    variant="h4"
                    sx={{ my: 1, textTransform: "uppercase" }}
                  >
                    Thông tin khách hàng
                  </Typography>
                  <Divider />
                  <Grid container spacing={2}>
                    <Grid item xs={8}>
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          id="isNewClient"
                          name="isNewClient"
                          onChange={handleChange}
                        >
                          <FormControlLabel
                            value="1"
                            control={<Radio checked />}
                            label="Khách hàng mới"
                          />
                          <FormControlLabel
                            value="2"
                            control={
                              <Radio
                                checked={parseInt(values.isNewClient) === 2}
                              />
                            }
                            label="Khách hàng cũ"
                          />
                        </RadioGroup>
                      </FormControl>
                      <TextField
                        error={Boolean(
                          touched.customerName && errors.customerName
                        )}
                        helperText={touched.customerName && errors.customerName}
                        onChange={handleChange}
                        autoFocus
                        size="small"
                        margin="normal"
                        id="customerName"
                        value={values.customerName}
                        label="Tên Khách hàng"
                        required
                        type="text"
                        fullWidth
                        variant="outlined"
                      />
                      <TextField
                        error={Boolean(
                          touched.customerIdNumber && errors.customerIdNumber
                        )}
                        helperText={
                          touched.customerIdNumber && errors.customerIdNumber
                        }
                        onChange={handleChange}
                        size="small"
                        margin="normal"
                        id="customerIdNumber"
                        value={values.customerIdNumber}
                        label="Số CMND/Hộ chiếu"
                        type="text"
                        fullWidth
                        variant="outlined"
                      />
                      <TextField
                        error={Boolean(touched.address && errors.address)}
                        helperText={touched.address && errors.address}
                        onChange={handleChange}
                        size="small"
                        margin="normal"
                        id="address"
                        value={values.address}
                        label="Địa chỉ"
                        type="text"
                        fullWidth
                        rows={2}
                        maxRows={4}
                        variant="outlined"
                      />
                      <TextField
                        error={Boolean(touched.phone && errors.phone)}
                        helperText={touched.phone && errors.phone}
                        onChange={handleChange}
                        size="small"
                        margin="normal"
                        id="phone"
                        value={values.phone}
                        label="Số điện thoại"
                        type="text"
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  <Typography
                    color="textPrimary"
                    variant="h4"
                    sx={{ my: 1, textTransform: "uppercase" }}
                  >
                    Thông tin Trả Góp
                  </Typography>
                  <Divider />
                  <Grid container spacing={2}>
                    <Grid item sm={12} md={8}>
                      <TextField
                        error={Boolean(
                          touched.collateralType && errors.collateralType
                        )}
                        helperText={
                          touched.collateralType && errors.collateralType
                        }
                        onChange={event => {
                          const newValue = event.target.value || "";
                          setFieldValue("collateralType", newValue);
                        }}
                        size="small"
                        margin="normal"
                        id="collateralType"
                        value={values.collateralType || ""}
                        label="Tên tài sản"
                        type="text"
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={8}>
                      <TextField
                        error={Boolean(touched.loanAmount && errors.loanAmount)}
                        helperText={touched.loanAmount && errors.loanAmount}
                        onChange={event => {
                          let newValue = event.target.value;
                          newValue =
                            parseInt(newValue.replace(/[^\d\\.]/g, "")) || "";
                          setFieldValue("loanAmount", newValue);
                        }}
                        size="small"
                        margin="normal"
                        id="loanAmount"
                        value={values.loanAmount.toLocaleString("en-US") || 0}
                        label="Trả Góp"
                        type="text"
                        fullWidth
                        variant="outlined"
                        disabled
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">VNĐ</InputAdornment>
                          )
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={12} md={8}>
                      <SearchDropdown
                        title="Hình thức lãi"
                        data={interestRateTypes || []}
                        error={Boolean(
                          touched.interestForm && errors.interestForm
                        )}
                        helperText={touched.interestForm && errors.interestForm}
                        value={values.interestForm}
                        onBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        required
                        id="interestForm"
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={12} md={8}>
                      <TextField
                        error={Boolean(
                          touched.numberPeriod && errors.numberPeriod
                        )}
                        helperText={touched.numberPeriod && errors.numberPeriod}
                        onChange={event => {
                          setFieldValue(
                            "numberPeriod",
                            parseInt(event.target.value)
                          );
                        }}
                        size="small"
                        margin="normal"
                        id="numberPeriod"
                        value={values.numberPeriod}
                        label={numberPeriodTex}
                        type="text"
                        fullWidth
                        variant="outlined"
                        required
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {textUnit}
                            </InputAdornment>
                          )
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={12} md={8}>
                      <TextField
                        error={Boolean(
                          touched.interestTerm && errors.interestTerm
                        )}
                        helperText={touched.interestTerm && errors.interestTerm}
                        onChange={event => {
                          setFieldValue(
                            "interestTerm",
                            parseInt(event.target.value)
                          );
                        }}
                        size="small"
                        margin="normal"
                        id="interestTerm"
                        value={values.interestTerm}
                        label="Kỳ lãi"
                        type="text"
                        fullWidth
                        variant="outlined"
                        required
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {textUnit}
                            </InputAdornment>
                          )
                        }}
                      />
                    </Grid>
                    <Grid item sm={12} md={4} alignItems="center" container>
                      <ArrowForwardOutlinedIcon />(<Box>{textExample}</Box>)
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={12} md={8}>
                      <TextField
                        error={Boolean(
                          touched.interestRate && errors.interestRate
                        )}
                        helperText={touched.interestRate && errors.interestRate}
                        onChange={event => {
                          setFieldValue(
                            "interestRate",
                            parseInt(event.target.value) || ""
                          );
                        }}
                        size="small"
                        margin="normal"
                        id="interestRate"
                        value={values.interestRate}
                        required
                        label="Lãi"
                        type="text"
                        fullWidth
                        variant="outlined"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              k/1 triệu
                            </InputAdornment>
                          )
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={12} md={8}>
                      <DemoContainer components={["DatePicker"]}>
                        <DatePicker
                          label="Ngày vay"
                          size="small"
                          id="loanDate"
                          format="DD/MM/YYYY"
                          value={values.loanDate}
                          onChange={newValue => {
                            setFieldValue(
                              "loanDate",
                              newValue !== null ? newValue : values.date
                            );
                          }}
                          sx={{
                            "& input": {
                              padding: "8.5px 14px"
                            }
                          }}
                        />
                      </DemoContainer>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={12} md={8}>
                      <TextField
                        error={Boolean(touched.notes && errors.notes)}
                        helperText={touched.notes && errors.notes}
                        onChange={handleChange}
                        size="small"
                        margin="normal"
                        id="notes"
                        value={values.notes}
                        label="Ghi chú"
                        type="text"
                        fullWidth
                        multiline
                        rows={5}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item sm={12} md={8}>
                      <TextField
                        error={Boolean(touched.receiver && errors.receiver)}
                        helperText={touched.receiver && errors.receiver}
                        onChange={handleChange}
                        size="small"
                        margin="normal"
                        id="receiver"
                        value={values.receiver}
                        label="NV thu tiền"
                        type="text"
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item sm={12} md={4} container alignItems="center">
                      <span>(Người đi thu tiền họ cho HĐ)</span>
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions
                  sx={{
                    borderTop: "1px solid rgba(224, 224, 224, 1)"
                  }}
                  className="justify-start"
                >
                  <Grid container spacing={2}>
                    <Grid item sm={12} md={12}>
                      <Button
                        variant="contained"
                        sx={{
                          marginRight: 2,
                          marginLeft: 2
                        }}
                        disabled={isSubmitting}
                        onClick={handleSubmit}
                        size="small"
                      >
                        Lưu lại
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={handleClose}
                        size="small"
                      >
                        Đóng
                      </Button>
                    </Grid>
                  </Grid>
                </DialogActions>
              </>
            );
          }}
        </Formik>
      </Dialog>
    </div>
  );
};
Edit.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  data: PropTypes.any
};

export default Edit;
